module.exports = __webpack_public_path__ + "img/element-rating.497d3bc.svg";